// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__4Lp13","tabsBox":"styles_tabsBox__1JnUm","createButton":"styles_createButton__1qZU_"};